import { Injectable } from '@angular/core';
import { SETTINGS, STANDARDINSTRUCTIONS } from '../common/constants/labels';
import { environment } from '../../environments/environment';
import { ApiService } from '../common/services/api/api.service';
import { Observable } from 'rxjs';
import { StandardInstruction } from '../common/models/standard-instruction';
@Injectable({
  providedIn: 'root'
})
export class StandarInstructionService {
  instructionDataURL = environment.APISETTINGS + STANDARDINSTRUCTIONS;
  constructor(private apisService: ApiService) { }
  getStandardInstructionData(): Observable<any> {
    return this.apisService.get(this.instructionDataURL);
  }
}
